import React, { useEffect } from 'react';
import cx from 'classnames';
import { Button } from 'antd';
import analytics from 'Src/components/Segment/analytics';
import styles from './index.module.less';

const capitalizeFirstLetter = source => source.charAt(0).toUpperCase() + source.slice(1);

const deSnake = (source) => {
  const lower = source.toLowerCase();
  const tokens = lower.split('_');
  const cTokens = tokens.map(capitalizeFirstLetter);
  return cTokens.join(' ');
};

const Step = ({
  children,
  isActive,
  isFirst,
  isHiddenBottom,
  isInvisiblePrevious,
  isVisiblePrevious,
  name: pageName,
  onBack,
  ...rest
}) => {
  useEffect(() => {
    if (isActive) {
      const deSnakedName = deSnake(pageName);
      analytics().page(deSnakedName);
    }
  }, [pageName, isActive]);

  const backButton = (
    <Button
      type="link"
      icon="left"
      onClick={onBack}
      style={{ visibility: (!isFirst && isActive) ? 'visible' : 'hidden' }}
    >
      Back
    </Button>
  );
  return (
    <div
      className={cx(styles.step, {
        [styles.stepActive]: isActive,
        [styles.stepVisibleTop]: isVisiblePrevious,
        [styles.stepHiddenTop]: isInvisiblePrevious,
        [styles.stepHiddenBottom]: isHiddenBottom,
      })}
      role="note"
      {...rest}
    >
      <div className={styles.stepInner}>
        {backButton}
        {children}
      </div>
    </div>
  );
};

export default Step;
